import * as React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { DISPLAYNAME_PREFIX, Classes } from "../../common";

const rowColWidths = ["xs", "sm", "md", "lg", "xl"];
const rowColsPropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

const propTypes = {
    //tag: React.Component,
    noGutters: PropTypes.bool,
    className: PropTypes.string,
    cssModule: PropTypes.object,
    form: PropTypes.bool,
    xs: rowColsPropType,
    sm: rowColsPropType,
    md: rowColsPropType,
    lg: rowColsPropType,
    xl: rowColsPropType,
};

const defaultProps = {
    //tag: "div",
    widths: rowColWidths,
};

type Props = {
    className?: string;
    noGutters?: boolean;
    form?: boolean;
    widths?: string[];
    [key: string]: any;
};

const Row = (props: Props) => {
    const { className, noGutters, /*tag: Tag,*/ form, widths = [], ...attributes } = props;

    const colClasses: string[] = [];

    widths.forEach((colWidth, i) => {
        let colSize = props[colWidth];

        delete attributes[colWidth];

        if (!colSize) {
            return;
        }

        const isXs = !i;
        colClasses.push(isXs ? `row-cols-${colSize}` : `row-cols-${colWidth}-${colSize}`);
    });

    const classes = classNames(
        className,
        noGutters ? Classes.GRID_NO_GUTTERS : null,
        form ? "form-row" : Classes.GRID_ROW,
        colClasses,
    );

    return <div {...attributes} className={classes} />;
    //return <Tag {...attributes} className={classes} />;
};

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
Row.displayName = `${DISPLAYNAME_PREFIX}.Row`;

export { Row };
